import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={ref} className="w-full h-screen flex overflow-hidden">
      {/* Left - Software side */}
      <div className="relative w-1/2 h-full flex flex-col items-center justify-center overflow-hidden" style={{ background: '#FB8E7E' }}>
        {/* Big decorative letter */}
        <span
          className="boldonse absolute text-white/10 select-none pointer-events-none"
          style={{ fontSize: '40vw', lineHeight: 1, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        >
          S
        </span>

        <Link
          to="/services"
          className={`relative z-10 transition-all duration-1000 delay-200 block ${visible ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-75 rotate-12'}`}
          style={{ transformOrigin: 'center' }}
        >
          <div className="w-72 h-72 flex items-center justify-center">
            <div className="w-48 h-48 rounded-3xl bg-white/20 backdrop-blur-sm flex items-center justify-center hover:rotate-6 transition-transform duration-500 cursor-pointer">
              <i className="ri-code-box-line text-white text-8xl" />
            </div>
          </div>
          <div className="absolute inset-0 flex items-end justify-center pb-2 opacity-0 hover:opacity-100 transition-opacity duration-300">
            <span className="bg-white/90 text-[#FA6E4F] text-xs boldonse px-4 py-1.5 rounded-full tracking-wider whitespace-nowrap">
              EXPLORE SOFTWARE →
            </span>
          </div>
        </Link>

        <div
          className={`relative z-10 mt-8 text-center transition-all duration-1000 delay-400 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="boldonse text-white text-5xl">SOFTWARE</p>
          <p className="text-white/70 text-sm mt-2 tracking-widest uppercase">Custom development solutions</p>
        </div>

        {/* Diagonal divider */}
        <div
          className="absolute right-0 top-0 bottom-0 w-16 z-20"
          style={{
            background: 'linear-gradient(to bottom right, #FB8E7E 50%, #C5D7C0 50%)',
            clipPath: 'polygon(100% 0, 100% 100%, 0 100%, 100% 0)'
          }}
        />
      </div>

      {/* Right - Digital side */}
      <div className="relative w-1/2 h-full flex flex-col items-center justify-center overflow-hidden" style={{ background: '#C5D7C0' }}>
        {/* Big decorative letter */}
        <span
          className="boldonse absolute text-white/20 select-none pointer-events-none"
          style={{ fontSize: '40vw', lineHeight: 1, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        >
          D
        </span>

        <Link
          to="/services"
          className={`relative z-10 transition-all duration-1000 delay-300 block ${visible ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-75 -rotate-12'}`}
          style={{ transformOrigin: 'center' }}
        >
          <div className="w-72 h-72 flex items-center justify-center">
            <div className="w-48 h-48 rounded-3xl bg-white/20 backdrop-blur-sm flex items-center justify-center hover:-rotate-6 transition-transform duration-500 cursor-pointer">
              <i className="ri-bar-chart-grouped-line text-white text-8xl" />
            </div>
          </div>
          <div className="absolute inset-0 flex items-end justify-center pb-2 opacity-0 hover:opacity-100 transition-opacity duration-300">
            <span className="bg-white/90 text-[#8EC9BB] text-xs boldonse px-4 py-1.5 rounded-full tracking-wider whitespace-nowrap">
              EXPLORE MARKETING →
            </span>
          </div>
        </Link>

        <div
          className={`relative z-10 mt-8 text-center transition-all duration-1000 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="boldonse text-white text-5xl">DIGITAL</p>
          <p className="text-white/70 text-sm mt-2 tracking-widest uppercase">Marketing &amp; advertising</p>
        </div>


      </div>
    </section>
  );
}